import { render, staticRenderFns } from "./UserSocialSelfies.vue?vue&type=template&id=1bd73347&"
import script from "./UserSocialSelfies.vue?vue&type=script&lang=js&"
export * from "./UserSocialSelfies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports